<script>
    import Button from 'views/components/button/Button.svelte'
    import Icon from 'views/components/icon/Icon.svelte'
    import SelfAssessmentUtil from 'views/pages/activities/show/types/selfAssessment/SelfAssessmentUtil';

    const {
        activityModel,
        selectedLearningGoals,
        onReviewCallback
    } = $props()

    const learningGoals = $derived(activityModel.get('self_assessment').learning_goals.filter(goal => selectedLearningGoals.includes(goal.id)))
    const hasAnyResponses = $derived(ACL.checkRole(ACL.roles.STUDENT) && activityModel.responses.length > 0)
    let isReviewing = $state(false)

    function onClickStop() {
        Backbone.history.navigate('/sections/show/' + activityModel.get('section_id'), {trigger: true})
    }

    function onClickTryAgain() {
        Backbone.history.loadUrl()
    }

    function onClickReview() {
        isReviewing = true
        onReviewCallback()
    }
</script>

<div class="container">
    <div class="result">
        <h2>{window.i18n.gettext('Test complete')}</h2>
        <div class="learning-goals">
            {#each learningGoals as learningGoal (learningGoal.id)}
                <div class="learning-goal">
                    {learningGoal.name}
                    {#if ACL.checkRole(ACL.roles.STUDENT)}
                        {@const isAchieved = SelfAssessmentUtil.isLearningGoalAchieved(learningGoal.id, activityModel)}
                        <div class="status">
                            {#if isAchieved}
                                <span class="achieved"><Icon name="checkmark-circle-fill"></Icon></span>
                                {window.i18n.gettext('Achieved')}
                            {:else}
                                <span class="not-achieved"><Icon name="checkmark-circle-fill"></Icon></span>
                                {window.i18n.gettext('Not achieved')}
                            {/if}
                        </div>
                    {/if}
                </div>
            {/each}
        </div>
        <div class="buttons">
            <Button
                label={window.i18n.gettext('Stop')}
                icon="cross"
                theme="secondary"
                size="medium"
                callback={onClickStop}>
            </Button>
            <Button
                label={window.i18n.gettext('Try again')}
                icon="refresh"
                theme="secondary"
                size="medium"
                callback={onClickTryAgain}>
            </Button>
            {#if hasAnyResponses}
                <Button
                    label={window.i18n.gettext('Review')}
                    iconRight="lightbulb"
                    theme="secondary"
                    size="medium"
                    callback={onClickReview}
                    disabled={isReviewing}
                    hasSpinner={isReviewing}>
                </Button>
            {/if}
        </div>
    </div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  position: absolute;
  inset: 0;
  display: flex;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: hsl(205, 60%, 44%);
  color: #fff;
}
.container .result {
  margin: auto;
  min-width: min(100%, 520px);
  max-width: 620px;
}
.container .result h2 {
  margin: 0;
}
.container .result .learning-goals {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  padding: 16px;
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.1);
}
.container .result .learning-goals .learning-goal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.container .result .learning-goals .learning-goal .status {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 6px 12px 6px 6px;
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.5);
}
.container .result .learning-goals .learning-goal .status .not-achieved {
  color: #fc7787;
}
.container .result .learning-goals .learning-goal .status .achieved {
  color: #3fd17d;
}
.container .result .learning-goals .learning-goal .status :global(svg) {
  fill: currentColor;
  display: flex;
  width: 20px;
  height: 20px;
}
.container .result .buttons {
  display: flex;
  gap: 16px;
  margin-top: 20px;
}</style>
